import { AfterViewChecked, Directive, ElementRef, Host, HostListener, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { GlobalEventsService } from '@coin/shared/core/util-helpers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[showTooltipIfTruncated]',
  providers: [MatTooltip],
  standalone: false,
  host: {
    '(mouseover)': 'onMouseOver()',
    '(mouseleave)': 'onMouseLeave()'
  }
})
export class TruncatedTooltipDirective implements AfterViewChecked {
  private matTooltip = inject(MatTooltip);
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private globalEvents = inject(GlobalEventsService);

  constructor() {
    this.globalEvents
      .listen('resize')
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.setTooltip());
  }

  public onMouseOver(): void {
    this.matTooltip.show();
  }

  public onMouseLeave(): void {
    this.matTooltip.hide();
  }

  public ngAfterViewChecked(): void {
    this.setTooltip();
  }

  private setTooltip(): void {
    const element = this.elementRef.nativeElement;
    this.matTooltip.message = element.textContent;
    this.matTooltip.disabled =
      element.scrollWidth <= element.clientWidth && element.scrollHeight <= element.clientHeight;
  }
}
